import React from "react";
import { getButtonProps, renderButtonContents, retainValidHTMLProps } from "./_internal/utils";
import type { RegrelloButtonProps } from "./types";

const VALID_BUTTON_TYPES = ["reset" as const, "submit" as const, "button" as const];

/**
 * A normal button allowing the user to manually trigger an action. Rendered as a `<button>`
 * element.
 */
const RegrelloButton = React.forwardRef<HTMLButtonElement, RegrelloButtonProps>((rawProps, ref) => {
  const buttonProps = getButtonProps(rawProps, ref);
  const { type, ...spreadableProps } = retainValidHTMLProps<HTMLButtonElement>(buttonProps);
  return (
    // (clewis): `type` is of type `string | undefined` when returned from retainValidHTMLProps—so
    // not narrowly typed enough. Use a type guard to appease TSC and ensure type is valid.
    //
    /* eslint-disable jsx-a11y/no-redundant-roles */
    // biome-ignore lint/a11y/useSemanticElements: E2E tests fail if we don't set role="button".
    // biome-ignore lint/a11y/noRedundantRoles: E2E tests fail if we don't set role="button".
    <button role="button" {...spreadableProps} type={isValidButtonType(type) ? type : "button"}>
      {renderButtonContents(buttonProps)}
    </button>
    /* eslint-enable jsx-a11y/no-redundant-roles */
  );
});
RegrelloButton.displayName = "RegrelloButton";

function isValidButtonType(type: string | undefined): type is "reset" | "submit" | "button" {
  return VALID_BUTTON_TYPES.includes(type as "reset" | "submit" | "button");
}

export { RegrelloButton };
